module.exports = __webpack_public_path__ + "static/media/greenCheck.66995441.png";